import React from "react";
import { useSelector } from "react-redux";

import { MagnoliaImage } from "@/components/atoms/image/image";
import CoversingleCard from "@/components/molecules/quote-section/quote-cover/cover-level-selection-card/cover-level-selection-card";
import {
  BenefitCopyDataType,
  CancellationCovers,
  CoverContentType,
  CoverDrawerDetailsDataType,
} from "@/schema/quote-page/page.schema";
import { RootState } from "@/store/root-reducer";

type MapQuoteCardProps = {
  benifitData?: BenefitCopyDataType[];
  coverDrawerCopy?: string;
  coverDrawerDetails: CoverDrawerDetailsDataType[];
  coverDrawerTitle?: string;
  coverTitle: string;
  coverType?: string;
  defaqtoRating: 1 | 2 | 3 | 4 | 5;
  whichBestBuyBadge?: MagnoliaImage;
  selectedCoverLevel: string;
  selectedTab: string;
  type: number;
  updateCoverType: boolean;
  isHideCard?: {
    basic?: boolean;
    comprehensive?: boolean;
    signature?: boolean;
    essentials?: boolean;
    classic?: boolean;
    deluxe?: boolean;
  };
  setCancellationCoverOpen: (val: boolean) => void;
  setCancelltionChangeCoverType: (val: string) => void;
  setDynamicCoverLimit: (val: CancellationCovers[] | null) => void;
  updateSelectedCoverLevel: (
    val: string,
    state: boolean,
    index: number
  ) => void;
  onTripTypeToggle?: (tripType: string) => void;
} & CoverContentType;

function MapQuoteCard(props: Readonly<MapQuoteCardProps>) {
  const {
    benifitData,
    cancelationCoverBtnLabel,
    cancelationCoverCancelCta,
    cancelationCoverDescription,
    cancelationCoverTitle,
    cancelationCoverUpdateCta,
    coverDrawerCopy = "",
    coverDrawerDetails,
    coverDrawerTitle = "",
    coverTitle,
    coverType,
    defaqtoRating,
    whichBestBuyBadge,
    onlineExclusiveBannerLabel,
    seeMoreDetailsBtnLabel,
    selectBtnLabel,
    selectedCoverLevel,
    selectedTab,
    type,
    updateCoverType,
    isHideCard,
    setCancellationCoverOpen,
    setCancelltionChangeCoverType,
    setDynamicCoverLimit,
    updateSelectedCoverLevel,
    onTripTypeToggle,
  } = props;

  const quoteData = useSelector((state: RootState) => state.quote);
  const { attributes } = quoteData;
  const { tripDetails } = attributes;

  return (
    <CoversingleCard
      keyValue={coverType ?? ""}
      cardTopData={{
        cardTitle: coverTitle,
        selectBtnActiveLable: selectBtnLabel.selectedLabel,
        selectBtnInactiveLable: selectBtnLabel.notSelectedLabel,
        isLoading: updateCoverType && selectedCoverLevel === coverType,
      }}
      cardBottomData={{
        tableData: benifitData,
        changeBtnLabel: cancelationCoverBtnLabel,
        cancelationCoverTitle,
        cancelationCoverDescription,
        cancelationCoverUpdateCta,
        cancelationCoverCancelCta,
        seeMoreDetailsBtnLabel,
        drawerData: {
          drawerTitle: coverDrawerTitle,
          drawerCopy: coverDrawerCopy,
          drawerDetails: coverDrawerDetails,
        },
        setCancellationCoverOpen,
        setDynamicCoverLimit,
        setCancelltionChangeCoverType,
      }}
      onSelect={(val, state, index) =>
        updateSelectedCoverLevel(val, state, index)
      }
      isSelect={
        tripDetails?.initialQuotePageLoading !== true &&
        tripDetails?.policyPackage === coverType
      }
      isHideCard={isHideCard}
      type={selectedTab}
      defaqtoStarts={defaqtoRating}
      whichBestBuyBadge={whichBestBuyBadge}
      onlineExclusiveBannerLabel={onlineExclusiveBannerLabel}
      id={type}
      onTripTypeToggle={onTripTypeToggle}
    />
  );
}

export default MapQuoteCard;
